import { beverageActionTypes, beverageActionTypesStepMap } from "../BeverageConstants";

export const getStepInitialState = (acid, cachedMessages, beverageConsentResponded) => {
  if (acid && cachedMessages && beverageConsentResponded) {
    return beverageActionTypesStepMap[beverageActionTypes.ThankYou];
  }
  if (acid && cachedMessages) {
    return beverageActionTypesStepMap[beverageActionTypes.OnsitePersonalization];
  }
  if (cachedMessages && !acid) {
    return beverageActionTypesStepMap[beverageActionTypes.Login];
  }

  return beverageActionTypesStepMap[beverageActionTypes.Start];
}